import { createContext, } from 'react';

export const LayoutContext = createContext(1,);

export const ColContext = createContext(1,);
